import * as React from 'react';
import { useForm } from 'react-hook-form';
import {
  Alert,
  Heading,
  TextField,
  Button,
  Row,
  Col,
  // FormattedTextField,
} from '@elevationscu/ui-component-lib';
import styles from '../App.module.scss';
import ProgressBar from './ProgressBar';
import DataDisclaimer from './data-disclaimer';
// import prospectPut from './helper-functions';
import { CREDIT_SCORES } from './constants';
import { prospectFinalSubmit } from './helper-functions';

export default function Page3({
  pageNumber, userInfo, setUserInfo, previousPage, maxPages,
}) {
  const {
    register, handleSubmit, clearErrors, formState: { errors, isValid },
  } = useForm({ mode: 'all' });

  // const [address, setAddress] = React.useState('');
  const [credit, setCredit] = React.useState();
  const [primaryReason, setPrimaryReason] = React.useState('Business Use');
  const [anythingElseQuestion, setAnythingElseQuestion] = React.useState('');
  const [submitMessage, setSubmitMessage] = React.useState('');
  const [messageTitle, setMessageTitle] = React.useState();
  const [messageType, setMessageType] = React.useState();

  const validationSchema = {
    city: {
      required: false,
    },
  };

  React.useEffect(() => {
    if (userInfo.application_data.credit) setCredit(userInfo.application_data.credit);
    if (userInfo.application_data.primaryReason) setPrimaryReason(userInfo.application_data.primaryReason);
    if (userInfo.application_data.anythingElseQuestion) setAnythingElseQuestion(userInfo.application_data.anythingElseQuestion);
    // eslint-disable-next-line
    }, [])

  function previous() {
    const tempUserInfo = {
      ...userInfo,
      application_data: {
        ...userInfo.application_data,
        credit,
        primaryReason,
        anythingElseQuestion,
      },
    };

    setUserInfo(tempUserInfo);
    previousPage(tempUserInfo);
  }

  React.useEffect(() => {
    clearErrors();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function submitApp() {
    try {
      const tempUserInfo = {
        ...userInfo,
        application_data: {
          ...userInfo.application_data,
          credit,
          primaryReason,
          anythingElseQuestion,
        },
      };

      setUserInfo(tempUserInfo);

      const finalizeResponse = await prospectFinalSubmit(tempUserInfo);

      if (finalizeResponse.status === 200) {
        window.location.href = `${process.env.REACT_APP_ENV_PUBLIC_WEB_ADDRESS}/business-heloc-questionnaire-submission`;
      } else {
        setSubmitMessage("Something happened.  We'll be working on fixing this as soon as possible, so try again soon.");
        setMessageTitle('Uh oh!');
        setMessageType('error');
      }
    } catch (error) {
      setSubmitMessage("Something happened.  We'll be working on fixing this as soon as possible, so try again soon.");
      setMessageTitle('Uh oh!');
      setMessageType('error');
      console.error(error);
    }
  }

  return (
    <div>
      <Row>
        <Col>
          <Heading size={2} element="h1" className={styles.dataFormHeader}>
            Just a few more questions...
          </Heading>
        </Col>
      </Row>
      <div className={styles.prospectInput}>
        <Row>
          <Col>
            <ProgressBar pageNumber={pageNumber} maxPages={maxPages} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Heading size={3} element="h2" className={styles.inputHeader}>
              What is your estimated credit rating? (required)
            </Heading>
          </Col>
        </Row>
        <div className={styles.dataInputs}>
          <Row className={styles.creditRadioButtonsRow}>
            <div role="radiogroup" aria-required="true" className={styles.radioButtons}>
              {CREDIT_SCORES.map((score) => (
                <Col xs={6} md={3} lg={3} xl={2} key={`credit-score-${score}`} className={styles.creditButtonCol}>
                  <Button
                    id={`credit-btn-${score}`}
                    onClick={() => setCredit(score)}
                    variant="secondary"
                    className={credit !== score ? styles.creditButton : styles.selectedCreditButton}
                    aria-label={score}
                    required="required"
                    role="radio"
                    aria-checked={score === credit}
                  >
                    {score}
                  </Button>
                </Col>
              ))}
              <Col lg={8} />
            </div>
          </Row>
          <Row>
            <Col>
              <Heading size={3} element="h2" className={styles.inputHeader}>
                Additional info
              </Heading>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={8}>
              <div className={styles.indivInput}>
                <TextField
                  type="text"
                  label="Please tell us anything else you’d like us to consider (optional)"
                  id="inputAnythingElseQuestion"
                  value={anythingElseQuestion}
                  error={errors.anythingElseQuestion && validationSchema.anythingElseQuestion.message}
                  {...register('anythingElseQuestion', { required: false, onChange: (e) => { setAnythingElseQuestion(e.target.value); } })}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={8}>
              <DataDisclaimer firstPage />
            </Col>
            {submitMessage
              && (
                <Col xs={12}>
                  <Alert title={messageTitle} variant={messageType} className={styles.alertBanner}>
                    {submitMessage}
                  </Alert>
                </Col>
              )}
            <Col xs={6} md={6} lg={2} className={styles.previousButtonCol}>
              <button onClick={previous} className={styles.previousButton} id="btn_previous" type="button">
                Previous
              </button>
            </Col>
            <Col xs={6} md={6} lg={2} className={styles.nextOrSubmitButtonCol}>
              <div className={styles.nextButton}>
                <Button
                  disabled={!isValid || !credit}
                  onClick={handleSubmit(() => {
                    submitApp();
                  })}
                  type="submit"
                  id="submit-button"
                >
                  Submit
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
